export default "__VITE_ASSET__CwHqI1JX__"